module.exports = __webpack_public_path__ + "static/media/rensair-logo.ebf1c5fb.png";